import React from 'react';
import { Icon, Tooltip, Dropdown } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import IconButton from '../../common/buttons/icon-button';
import StyledIcon from '../../form/styled/icon';
import {
  getInternetAccess,
  getAutoSaveDraft,
} from 'APP_ROOT/selectors/application';

import { connect } from 'react-redux';

const ActionButtons = props => {
  const { actions = [], internetAccess, isPreviewMode, autoSaveDraft } = props;

  const getButtonWithTooltip = (action, index) => {
    // const { internetAccess, isPreviewMode } = props;
    return (
      <Tooltip
        title={action?.tooltipMessage || ''}
        placement="bottom"
        autoAdjustOverflow
        getPopupContainer={trigger => trigger.parentNode}
        overlayClassName="page-header-tooltip"
      >
        <IconButton
          key={index}
          shape="circle"
          disabled={action.loading || !internetAccess || isPreviewMode}
          onClick={e => action.onButtonClick()(e, action)}
          data-preview-mode={isPreviewMode}
          data-test-id={action?.dataTestId}
        >
          {action.loading ? (
            <Icon type="loading" />
          ) : action.type === 'icon' ? (
            <StyledIcon type={action.icon} />
          ) : (
            <img src={action.icon} alt="Button" />
          )}
        </IconButton>
      </Tooltip>
    );
  };

  const getLetterTemplatesDropdown = (action, index) => {
    const {
      internetAccess,
      letterTemplates,
      match: {
        params: { id: reportId },
      },
    } = props;

    const menu = action.menu(letterTemplates, reportId);

    return (
      <Tooltip
        id="letter-templates-tooltip"
        title={action?.tooltipMessage || ''}
        placement="bottom"
        autoAdjustOverflow
        getPopupContainer={trigger => trigger.parentNode}
        overlayClassName="page-header-tooltip"
      >
        <Dropdown
          overlay={menu}
          trigger={['click']}
          getPopupContainer={trigger => trigger.parentNode}
          onVisibleChange={visible => {
            const tooltip = document.querySelector('#letter-templates-tooltip');
            if (tooltip) {
              if (visible) {
                // Dropdown opened - hide tooltip and keep it hidden
                tooltip.style.opacity = '0';
                tooltip.style.visibility = 'hidden';
                tooltip.style.pointerEvents = 'none';
              } else {
                // Dropdown closed - restore tooltip behavior
                tooltip.style.opacity = '';
                tooltip.style.visibility = '';
                tooltip.style.pointerEvents = '';
              }
            }
          }}
        >
          <IconButton
            key={index}
            shape="circle"
            disabled={action.loading || !internetAccess}
          >
            {action.loading ? (
              <Icon type="loading" />
            ) : (
              <StyledIcon type={action.icon} />
            )}
          </IconButton>
        </Dropdown>
      </Tooltip>
    );
  };

  return (
    <div className="form-actions__buttons">
      {actions.map((action, index) => {
        if (action.href) {
          return (
            <Link
              to={action.href}
              target={action.target || '_self'}
              key={index}
              disabled={!internetAccess || isPreviewMode || autoSaveDraft}
            >
              {getButtonWithTooltip(action, index)}
            </Link>
          );
        } else if (action.type == 'dropdown') {
          return getLetterTemplatesDropdown(action, index);
        }

        return getButtonWithTooltip(action, index);
      })}
    </div>
  );
};

const mapState = (state, props) => {
  const {
    report: { letterTemplates },
  } = state;
  return {
    letterTemplates,
    internetAccess: getInternetAccess(state),
    autoSaveDraft: getAutoSaveDraft(state),
  };
};

export default connect(mapState)(withRouter(ActionButtons));
